import { Avatar, TableCell, TableRow, Typography } from '@mui/material';
import useComponentSize from '@rehooks/component-size';
import * as React from 'react';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';
import { formatCurrency, formatNumber } from '~/services/Formatters';
import { ICompensationDto } from '~/services/Http/client.people.generated';

import { useSxStyles } from './useStyles';

export interface TeamMemberCompensationProps {
  tableRow: ICompensationDto;
  isTabDisabled?: boolean;
}

const handleRowClick = (empId: number) => {
  window.location.href = `/page-ui2-redirect?empId=${empId}&area=rewarding`;
};
export const TeamMemberCompensation: React.FC<TeamMemberCompensationProps> = ({
  tableRow,
  isTabDisabled,
}) => {
  const sxStyles = useSxStyles();

  const widgetContentRef = React.useRef<HTMLTableRowElement>(null);
  const { width: widgetContentWidth } = useComponentSize(widgetContentRef);
  const minSizeRender = widgetContentWidth < 320;
  const tableRowProps = isTabDisabled
    ? {
        hover: !isTabDisabled,
      }
    : {
        sx: sxStyles.row,
        onClick: () => handleRowClick(tableRow.employee!.id),
        hover: !isTabDisabled,
      };

  return (
    <TableRow {...tableRowProps} ref={widgetContentRef}>
      <TableCell sx={sxStyles.cell} data-cy="profile-pic">
        <Avatar
          alt={tableRow.employee!.firstName}
          src={tableRow.employee!.profilePic}
        />
      </TableCell>
      {minSizeRender ? (
        <TableCell align="right" sx={sxStyles.cell}>
          <Typography
            component="div"
            sx={sxStyles.nameCell}
            variant="body2"
            data-cy="name"
          >
            {`${tableRow.employee!.firstName?.charAt(
              0,
            )}. ${tableRow.employee!.lastName?.charAt(0)}.`}
          </Typography>
        </TableCell>
      ) : (
        <TableCell sx={sxStyles.cell}>
          <Typography component="div" variant="body2">
            <TooltippedTruncatedText dataCy="name">
              {`${tableRow.employee!.firstName} ${tableRow.employee!.lastName}`}
            </TooltippedTruncatedText>
          </Typography>
        </TableCell>
      )}
      <TableCell align="right" sx={sxStyles.cell}>
        <TooltippedTruncatedText dataCy="salary-frequency">
          {tableRow.salaryFrequency}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell}>
        <TooltippedTruncatedText dataCy="base-salary">
          {formatNumber(tableRow.baseSalary, 2)}
          {formatCurrency(tableRow.currency)}
        </TooltippedTruncatedText>
      </TableCell>
    </TableRow>
  );
};
